import { useState, useEffect, useCallback } from 'react';
import { matchingService } from '@/services/matching.service';
import type { FipeVehicle, NeverTestedFipeVehicle, PbevVehicle } from '@/types';

export const useUnmatchedVehicles = () => {
  const [fipe, setFipe] = useState<FipeVehicle[]>([]);
  const [neverTested, setNeverTested] = useState<NeverTestedFipeVehicle[]>([]);
  const [pbev, setPbev] = useState<PbevVehicle[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchUnmatched = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const [fipeData, neverTestedData, pbevData] = await Promise.all([
        matchingService.getUnmatchedFipe(),
        matchingService.getNeverTestedFipe(),
        matchingService.getUnmatchedPbev(),
      ]);
      setFipe(fipeData);
      setNeverTested(neverTestedData);
      setPbev(pbevData);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch unmatched vehicles');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUnmatched();
  }, [fetchUnmatched]);

  return { fipe, neverTested, pbev, loading, error, refetch: fetchUnmatched };
};
